import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_ANTI_PASSBACK = "access-control-service/anti-passbacks";

const RESOURCES = {
   LIST_GROUPS_PAGINATED: (
      page,
      searchText,
      condominiumId,
      licenceId,
      orderBy,
   ) =>
      `${BASE_ANTI_PASSBACK}/condominiums/${condominiumId}/licences/${licenceId}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,

   CREATE_ANTI_PASSBACK: () => BASE_ANTI_PASSBACK,
   CREATE_BULK_ANTI_PASSBACKS: () => `${BASE_ANTI_PASSBACK}/bulk-by-ids`,
   DELETE_ANTI_PASSBACK: (accessGroupId) =>
      `${BASE_ANTI_PASSBACK}/${accessGroupId}`,
   UPDATE_ANTI_PASSBACK: (accessGroupId) =>
      `${BASE_ANTI_PASSBACK}/${accessGroupId}`,
   LIST_CONDOMINIUM_ANTI_PASSBACK: (condominiumId) =>
      `${BASE_ANTI_PASSBACK}/condominiums/${condominiumId}`,
   GET_ONE_UUID: (uuid) => `${BASE_ANTI_PASSBACK}/uuid/${uuid}`,
};

class AntiPassbackService {
   static async listAntiPassbacksPaginated(
      page,
      searchText,
      condominiumId,
      licenceId,
      orderBy,
      cancelToken,
   ) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_GROUPS_PAGINATED(
               page,
               searchText,
               condominiumId,
               licenceId,
               orderBy,
            ),
            {
               signal: cancelToken,
            }
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar intertravamentos",
         });
         return error.response;
      }
   }

   static async listCondominiumAntiPassbacks(condominiumId) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_CONDOMINIUM_ANTI_PASSBACK(condominiumId),
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar intertravamentos do condomínio",
         });
         return error.response;
      }
   }

   static async getOneUuid(uuid) {
      try {
         return await axios.get(RESOURCES.GET_ONE_UUID(uuid));
      } catch (error) {
         console.error(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao obter intertravamento de acesso",
         });
         return error.response;
      }
   }

   static async createAntiPassback(payload) {
      try {
         const response = await axios.post(
            RESOURCES.CREATE_ANTI_PASSBACK(),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Anti Passback cadastrado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao cadastrar intertravamento",
         });
         return error.response;
      }
   }

   static async createBulkAntiPassbacks(payload) {
      try {
         const response = await axios.post(
            RESOURCES.CREATE_BULK_ANTI_PASSBACKS(),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Anti Passback cadastrado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao cadastrar intertravamento",
         });
         return error.response;
      }
   }

   static async updateAntiPassback(accessGroupId, payload) {
      try {
         const response = await axios.put(
            RESOURCES.UPDATE_ANTI_PASSBACK(accessGroupId),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Anti Passback editado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao editar intertravamento",
         });
         return error.response;
      }
   }
   static async deleteAntiPassback(accessGroupId) {
      try {
         const response = await axios.delete(
            RESOURCES.DELETE_ANTI_PASSBACK(accessGroupId),
         );
         ResponseAlerts({
            response: response,
            successMessage: "Anti Passback excluído com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao excluir intertravamento",
         });
         return error.response;
      }
   }
}
export default AntiPassbackService;
